module.exports = "<p>\n  incassi-list works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/incassi/incassi-list.component.html
// module id = ../../../../../src/app/components/incassi/incassi-list.component.html
// module chunks = main